import { Box, Typography, Grid } from '@mui/material';

//exportar fuera de este archivo
export interface Discount {
  name: string;
  value: string;
}

export interface DisplayCouponProps {
  Discount: Discount;
  cost: number;
}
//exportar fuera de este archivo

export const DisplayCoupon: React.FC<DisplayCouponProps> = ({
  Discount,
  cost,
}) => {
  return (
    <Grid container lg={12} sx={{ marginTop: '30px' }}>
      <Box
        sx={{
          backgroundColor: '#F2F5F7',
          height: '88px',
          paddingTop: '21px',
          paddingLeft: '17px',
          paddingRight: '17px',
          paddingBottom: '5px',
          borderRadius: '8px',
        }}
      >
        <Box>
          <Typography fontSize={'14px'} fontWeight={'bold'}>
            {'Descuento'}
          </Typography>
        </Box>
        <Box marginTop={1}>
          <Typography fontSize={'13px'} fontWeight={'normal'}>
            {
              'Descuento ¡Qué felicidad! Te reembolsaremos 10% a tu cuenta en los próximos 30 días. Checa tu correo, porque ahí te diremos qué sigue en cuanto finalices tu compra.'
            }
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};
